// extracted by mini-css-extract-plugin
export default {"viewSection":"_2Qef","viewGroup":"_3Td0","viewLabel":"-S1K"};